import { LumeFxSide } from '@/types/lumeFx';
import { UseCurrencyReturn } from '@/utils/hooks/useCurrency';
import { UseInstrumentReturn } from '@/utils/hooks/useInstrument';
import { getLanguage } from '@/utils/hooks/useLanguage';

interface OrderMessageParams {
    side: LumeFxSide;
    isCcy2Order: boolean;
    ccy1Config: UseCurrencyReturn;
    ccy2Config: UseCurrencyReturn;
    pairMapToUse?: { show: string; celer: string; netdania: string };
    instrumentConfig?: UseInstrumentReturn;
}
export function formatOrderMessage({
    side,
    isCcy2Order,
    ccy1Config,
    ccy2Config,
    pairMapToUse,
    instrumentConfig
}: OrderMessageParams) {
    const lang = getLanguage();

    const lowerSide = LumeFxSide[side].toLowerCase();
    const lowerOtherSide = LumeFxSide[side === 1 ? 2 : 1].toLowerCase();

    const isCFD = ['Index', 'Commodity', 'Future'].includes(instrumentConfig?.type || '');

    if (!isCFD) {
        if (!isCcy2Order) {
            return `${lang.orderForm[lowerSide]} ${ccy1Config.show} / ${lang.orderForm[lowerOtherSide]} ${ccy2Config.show}`;
        } else {
            return `${lang.orderForm[lowerSide]} ${ccy2Config.show} / ${lang.orderForm[lowerOtherSide]} ${ccy1Config.show}`;
        }
    } else {
        return `${lang.orderForm[lowerSide]} ${pairMapToUse?.show}`;
    }
}
